import {IComponentOptions, IFilterService, ILogService, IPromise} from 'angular';
import AuthServiceRS from '../../../authentication/service/AuthServiceRS.rest';
import {getKantonCodeList, TSKantonCode} from '../../../models/enums/TSKantonCode';
import {getTSSchadenfallStatusalues, getTSSchadenfallStatusNeu, TSSchadenfallStatus} from '../../../models/enums/TSSchadenfallStatus';
import {getTSSpracheValues, TSSprache} from '../../../models/enums/TSSprache';
import TSBenutzer from '../../../models/TSBenutzer';
import TSSchadenfaelleSearchresultDTO from '../../../models/TSSchadenfaelleSearchresultDTO';
import TSSchadenfall from '../../../models/TSSchadenfall';
import TSSchadenfallDTO from '../../../models/TSSchadenfallDTO';
import TSSchadenfallPreFilterDTO from '../../../models/TSSchadenfallPreFilterDTO';
import {RemoveDialogController} from '../../dialog/RemoveDialogController';
import {DvDialog} from '../../directive/dv-dialog/dv-dialog';
import FilterPersistenceService from '../../service/FilterPersistenceService';
import IsNeuInStatusService from '../../service/isNeuInStatusService';
import OverdueService from '../../service/OverdueService';
import RoleUtilService from '../../service/RoleUtilService';
import SchadenfallModelManager from '../../service/SchadenfallModelManager';
import IScope = angular.IScope;
import IWindowService = angular.IWindowService;
import ITranslateService = angular.translate.ITranslateService;

let template = require('./dv-schadenfaelle-list.html');
require('./dv-schadenfaelle-list.scss');

let removeDialogTemplate = require('../../../core/dialog/removeDialogTemplate.html');

export class DVSchadenfaelleListConfig implements IComponentOptions {
    transclude = false;

    bindings: any = {
        onEdit: '&',
        onDeckblatt: '&?',
        onDelete: '&?',
        onFilterChange: '&',
        prefilter: '=',
        tabindex: '@',
        selectedtab: '=',
        verantwortliche: '<',
        onVerantwortlicherChange: '&',
        showVerantwortlicherFilter: '<',
        changeVerantwortlicherEnabled: '<',
    };
    template = template;
    controller = DVSchadenfaelleListController;
    controllerAs = 'vm';
}

export class DVSchadenfaelleListController {

    verantwortliche: Array<TSBenutzer>;
    verantwortlicheForFilter: Array<TSBenutzer> = [];
    prefilter: TSSchadenfallPreFilterDTO;

    displayedCollection: Array<TSSchadenfallDTO> = []; //Liste die im Gui angezeigt wird
    pagination: any;

    public selectedFallNummer: string;
    public selectedGesuchstellerName: string;
    public selectedEreignis: string;
    public selectedOrt: string;
    public selectedGesuchsdatumVon: string;
    public selectedGesuchsdatumBis: string;
    public selectedStatus: string;
    public selectedVerantworlticher: string;
    public selectedKostenVon: number | undefined;
    public selectedKostenBis: number | undefined;
    public selectedSprache: TSSprache | undefined;
    public selectedKanton: TSKantonCode | undefined;

    public showResetFilter: boolean = false;
    onFilterChange: (changedTableState: any) => IPromise<any>;
    onEdit: (pensumToEdit: any) => void;
    onDeckblatt: (schadenfall: any) => void;
    onDelete: (schadenfall: any) => void;
    onVerantwortlicherChange: (schadenfallVerantwortlicher: any) => void;
    showVerantwortlicherFilter: boolean;

    nichtZugeteiltMarker = 'NICHT_ZUGETEILT';

    tabindex: string;
    selectedtab: number; // indexID der aktuellen Schadenfalltabelle (es gibt mehrere)
    defaultTableFilterState: any = {
        sort: {},
        search: {},
        pagination: {start: 0, totalItemCount: 0, number: 30},
    };

    static $inject: any[] = [
        '$filter', '$log', 'CONSTANTS', '$scope', 'RoleUtilService', '$window', '$translate', 'FilterPersistenceService', 'DvDialog',
        'OverdueService', 'AuthServiceRS', 'IsNeuInStatusService', 'SchadenfallModelManager',
    ];

    /* @ngInject */
    constructor(
        private $filter: IFilterService,
        private $log: ILogService,
        private CONSTANTS: any,
        private $scope: IScope,
        private roleUtilService: RoleUtilService,
        private $window: IWindowService,
        private $translate: ITranslateService,
        private filterPersistenceService: FilterPersistenceService,
        private dvDialog: DvDialog,
        private overdueService: OverdueService,
        private authServiceRS: AuthServiceRS,
        private isNeuInStatusService: IsNeuInStatusService,
        private schadenfallModelManager: SchadenfallModelManager,
    ) {
        this.initViewModel();
    }

    private initViewModel() {

    }

    $onInit() {

        if (this.verantwortliche === undefined || this.verantwortliche === null) {
            this.$log.debug('list of verantwortliche is empty');
            this.verantwortliche = [];
        }
        // this creates a dummy element for the filter header; this could be done using ng-repeat on the option element but that is slow in ie.
        if (this.verantwortliche) {
            let nichtZugeteiltElements;
            angular.copy(this.verantwortliche, this.verantwortlicheForFilter);
            nichtZugeteiltElements = this.verantwortliche.filter((entry) => {
                return entry.email === this.nichtZugeteiltMarker;
            });
            if (nichtZugeteiltElements.length === 0) {
                let nichtZugeteiltDummy = new TSBenutzer();
                nichtZugeteiltDummy.email = this.nichtZugeteiltMarker;
                nichtZugeteiltDummy.nachname = this.$translate.instant(this.nichtZugeteiltMarker);

                this.verantwortlicheForFilter = [nichtZugeteiltDummy].concat(this.verantwortlicheForFilter);

            }
        }

    }

    editClicked(schadenfallEdit: any, event: any) {
        this.onEdit({schadenfall: schadenfallEdit, event: event});
    }

    private callServer = (tableFilterState: any) => {
        //wenn aktuelles tab nicht gewaehltes ist machen wir nichts
        if (this.selectedtab !== parseInt(this.tabindex)) {
            return;
        }

        let pagination = tableFilterState.pagination;
        this.pagination = pagination;

        if (this.onFilterChange && angular.isFunction(this.onFilterChange)) {
            this.onFilterChange({
                tableState: tableFilterState,
                prefilter: this.prefilter,
            }).then((result: TSSchadenfaelleSearchresultDTO) => {
                if (result) {
                    tableFilterState.pagination.totalItemCount = result.totalResultSize;
                    tableFilterState.pagination.numberOfPages = Math.ceil(result.totalResultSize / tableFilterState.pagination.number);
                    this.displayedCollection = new Array<TSSchadenfallDTO>().concat(result.schadenfallDTOs);
                }
                return this.displayedCollection;
            }).then((dtos) => {
                if (dtos) {
                    dtos.forEach(dto => {
                        this.schadenfallModelManager.openSchadenfall(dto.schadenfallId).then(
                            (schadenfall: TSSchadenfall) => {
                                dto.totalSchaetzung = schadenfall.getAbrechnungsbetrag(true);
                            });
                    });
                }
            });
        } else {
            this.$log.info('no callback function spcified for filtering');
        }
    };

    /**
     * Alle TSSchadenfaelleStatus fuer das Filterdropdown
     * @returns {Array<TSSchadenfaelleStatus>}
     */
    public getSchadenfaelleStatus(): Array<TSSchadenfallStatus> {
        if (this.prefilter.filterStatus && this.prefilter.status) {
            return this.prefilter.status;
        } else {
            return getTSSchadenfallStatusalues();
        }
    }

    /**
     * Alle TSKantonCode fuer das Filterdropdown
     * @returns {Array<key: string; code: TSKantonCode>}
     */
    public getKantone(): { key: string; code: TSKantonCode }[] {
        let kantonCodes: TSKantonCode[] = getKantonCodeList();
        let kantonNamesAndCodes: {
            key: string
            code: TSKantonCode
        }[] = [];

        kantonCodes.forEach(code => {
            kantonNamesAndCodes.push({
                key: this.$translate.instant(code.toString()),
                code: code,
            });
        });

        kantonNamesAndCodes.sort((a, b) => a.code.toString().localeCompare(b.code.toString()));

        return kantonNamesAndCodes;
    }

    /**
     * Alle TSSchadenfaelleStatus fuer das Filterdropdown
     * @returns {Array<TSSchadenfaelleStatus>}
     */
    public getAlleVerantwortliche(): Array<TSBenutzer> {
        return this.verantwortliche;
    }

    public getColumnsNumber(): number {
        let element = angular.element('.dv-schadenfaelle-list.' + this.getClass() + ' .header-row').first();
        if (element && element.get(0)) {
            return element.get(0).childElementCount;
        }
        //could not determine actual number, just returing an approximation
        return 8;
    }

    public updateVerantwortlicher(schadenfallId: string, verantwortlicher: string) {

        if (this.onVerantwortlicherChange && angular.isFunction(this.onVerantwortlicherChange)) {
            this.onVerantwortlicherChange({
                schadenfallId: schadenfallId,
                verantwortlicher: verantwortlicher,
            });
        } else {
            this.$log.info('no callback function specified for changing verantwortlicher');
        }
    }

    public getClass(): string {
        return 'tab-nr-' + this.tabindex;
    }

    public getVerantwortlicher(verantwortlicherEmail: string): string {
        if (!verantwortlicherEmail) {
            return this.$translate.instant(this.nichtZugeteiltMarker);
        } else {
            for (let verantwortlicher of this.verantwortliche) {
                if (verantwortlicher.email === verantwortlicherEmail) {
                    return verantwortlicher.getFullName();
                }
            }
        }
        return '';
    }

    public resetFilter(): void {
        this.filterPersistenceService.deleteFilter(`st-table-${this.tabindex}`);
    }

    deckblattClicked(schadenfallEdit: any, event: any) {
        this.onDeckblatt({schadenfall: schadenfallEdit, event: event});
    }

    isInStatusNEU(schadenFallStatus: any): boolean {
        let statusNeu = getTSSchadenfallStatusNeu();
        return statusNeu.some(status => status === schadenFallStatus);
    }

    deleteSchadenfallClicked(schadenFall: any, event: any) {
        this.dvDialog.showDialog(removeDialogTemplate, RemoveDialogController, {
            text: 'SCHADENFALL_LOESCHEN_TEXT',
            title: 'SCHADEN_LOESCHEN',
        }).then(() => {   //User confirmed removal
            this.onDelete({schadenfallId: schadenFall.schadenfallId, event: event});
        }).catch((reason) => {
            console.error('error could not delete schaden', reason);
        });
    }

    public translateSprache(sprache: TSSprache): string {
        if (sprache === undefined) {
            return '-';
        }
        return this.$translate.instant(TSSprache[sprache]);

    }

    private getTSSpracheValues(): Array<TSSprache> {
        return getTSSpracheValues();
    }

    public translateTSSpracheShort(sprache: TSSprache): string {
        let prefix = 'short_';
        return this.$translate.instant(prefix + TSSprache[sprache])
    }

    public shouldHighlightOverdueSchadenfall(fall: TSSchadenfallDTO): boolean {
        let roles = this.authServiceRS.getPrincipalRoles();
        if (roles) {
            let highestRoleOfBenutzer = this.authServiceRS.getHighestRoleOfBenutzer(roles);
            let status = fall.status;
            let overdueVisibleForStatusAndRole = this.overdueService.isOverdueVisibleForStatusAndRole(highestRoleOfBenutzer, status);

            return !!fall.isOverdue && overdueVisibleForStatusAndRole;
        }
        return false;
    }

    public shouldHighlightIsNeuInStatusSchadenfall(fall: TSSchadenfallDTO): boolean {
        let roles = this.authServiceRS.getPrincipalRoles();
        if (roles) {
            let highestRoleOfBenutzer = this.authServiceRS.getHighestRoleOfBenutzer(roles);
            let status = fall.status;
            let isNeuInStatusVisibleForStatusAndRole = this.isNeuInStatusService.isIsNeuInStatusVisibleForStatusAndRole(highestRoleOfBenutzer, status);

            return !!fall.newInStatus && isNeuInStatusVisibleForStatusAndRole;
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/component/dv-schadenfaelle-list/dv-schadenfaelle-list.ts